export var DIRECTION_FORWARD = 'forward';
export var DIRECTION_BACKWARD = 'backward';